module.exports = __webpack_public_path__ + "static/media/SF_bm_engl_sekundaerlogo_postale_rogaland_pos.ca4b2df1.png";